import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import TextEditor from '../../shared/TextEditor';
import AutoCompletedTextField from '../../shared/AutoCompletedTextField';
import RowTitle from '../RowTitle';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    inputBlock: {
      borderRadius: 24,
      padding: '12px 16px',
      backgroundColor: color.$19,
      display: 'inline-block',
    },
    tip: {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 'normal',
      color: color.$11,
      marginBottom: 12,
    },
    tags: {
      maxWidth: 601,
      marginBottom: 12,
      '& textarea': {
        minHeight: 'auto',
      },
    },
  },
  {
    name: 'CompetingProductsResponse',
  },
);

const CompetingProductsResponse = ({
  isChecked,
  onSwitchChange,
  tags = [],
  value,
  onChange,
  isSaved,
  disabled,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathKey } = useSelector(store => store.aiBot);

  return (
    <div className={classes.root}>
      <RowTitle
        title={t(
          `${pathKey}:advanceSettingContainer.competingProductsResponse`,
        )}
        isChecked={isChecked}
        onSwitchChange={onSwitchChange}
        isEnableSwitch
        disabled={disabled}
      />
      {isChecked && (
        <div className={classes.inputBlock}>
          <AutoCompletedTextField
            className={classes.tags}
            placeholder={t(
              `${pathKey}:advanceSettingContainer.competingProductsPlaceholder`,
            )}
            candidates={[]}
            defaultTags={tags}
            type="inline"
            onEnterEvent={tagName => {
              onChange({
                values: [...tags, tagName],
              });
            }}
            onSetTags={tagNames => {
              onChange({
                values: tagNames,
              });
            }}
            onChange={() => {}}
            disabled={disabled}
            multiline
          />
          <TextEditor
            onChange={v => onChange({ replyMessage: v })}
            origriData={value}
            placeholder={t(
              `${pathKey}:advanceSettingContainer.competingProductsResponsePlaceholder`,
            )}
            maxLength={0}
            isError={isSaved && !value}
            style={{ width: 601 }}
            disabled={disabled}
            isShowEmoji={false}
            isShowCustomerName={false}
          />
        </div>
      )}
    </div>
  );
};

export default CompetingProductsResponse;
